export const priceEvalColor = (rating) => {
  switch (rating) {
    case 1:
      return 'rgb(182, 32, 26)'
    case 2:
      return 'rgb(232, 209, 48)'
    case 3:
      return 'rgb(0, 203, 142)'
    case 4:
      return 'rgb(115, 175, 53)'
    case 5:
      return 'rgb(10, 151, 46)'
    default:
      return null
  }
}
